import React from 'react';

function CustomImage(props) {
  console.log(props.style);
  return <img src={require(`../images/${props.path}`)} alt={props.alt} style={props.style}/>
}

export default CustomImage